import FormService from "@/service/FormService";

export default new class ResponseService {
    handleErrorResponseWithForm(err, form, toast) {
        if (err.code === -32602 && Array.isArray(err.data)) {
            FormService.processErrorForm(form, err.data)
            return
        }
        FormService.clearForm(form)
        toast.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: typeof err.data === 'string' ? err.data : 'Внутренняя ошибка обработки',
            life: 2000
        })
    }

    handleErrorResponseWithoutForm(err, toast) {
        toast.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: typeof err.data === 'string' ? err.data : 'Внутренняя ошибка обработки',
            life: 2000
        })
    }

    handleFeedbackResponse(data, toast) {
        toast.add({
            severity: 'success',
            summary: 'Выполнено',
            detail: data.feedback,
            life: 2000
        })
    }

    getConvertEventId(err) {
        if (!err) {
            return null
        }

        if (err.data && typeof err.data === 'object' && err.data.eventId) {
            return Number(err.data.eventId)
        }

        if (err.eventId) {
            return Number(err.eventId)
        }

        const text = typeof err.data === 'string'
            ? err.data
            : (typeof err.message === 'string' ? err.message : '')

        if (!/сконвертировать событие/i.test(text)) {
            return null
        }

        const match = text.match(/событие\s*№\s*(\d+)/i)
        return match ? Number(match[1]) : null
    }
}